'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { type ReactNode, useEffect, useState } from 'react';
import { AUTH_SESSION_QUERY_KEY } from '../features/auth/constants';
import { readStoredSession } from '../features/auth/lib/authSessionStorage';
import { bindApiAuthQueryClient } from '../services/api';
import { applyThemeFromConfig } from '../theme/apply-theme';

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(() => {
    const client = new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          retry: 1,
          staleTime: 60_000,
          gcTime: 1_800_000,
        },
        mutations: {
          retry: 0,
        },
      },
    });
    const session = readStoredSession();
    if (session) {
      client.setQueryData(AUTH_SESSION_QUERY_KEY, session);
    }
    bindApiAuthQueryClient(client);
    return client;
  });

  useEffect(() => {
    applyThemeFromConfig();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
